import React from "react";
import { LegalLayout, Section } from "@/components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="Last updated: June 2026" testid="privacy-page">
      <Section heading="What we store, and why">
        <p>
          Mirror is operated by <strong className="text-[var(--mirror-text)]">Gnosis Dynamics
          LLC</strong>. When you converse with Mirror, your conversation transcripts are stored{" "}
          <strong className="text-[var(--mirror-text)]">solely to provide your reflection history
          and to generate your Journey entries</strong>. That is the only reason your words are
          kept — so you can return to earlier conversations and see the reflections drawn from them.
        </p>
      </Section>

      <Section heading="We never sell your data">
        <p>
          Your data is <strong className="text-[var(--mirror-text)]">never sold</strong> and is{" "}
          <strong className="text-[var(--mirror-text)]">never used for advertising or ad
          targeting</strong>. We do not share your conversations with third parties for marketing
          of any kind.
        </p>
      </Section>

      <Section heading="Analytics capture counts, never your words">
        <p>
          We use privacy-preserving analytics to understand how the app is used. These analytics
          capture only <strong className="text-[var(--mirror-text)]">anonymized counts and
          events</strong> — for example, that a conversation was started or a message was sent.
          They <strong className="text-[var(--mirror-text)]">never include the text of your
          messages</strong>, your conversations, or your Journey entries.
        </p>
      </Section>

      <Section heading="Your right to deletion">
        <p>
          You have the <strong className="text-[var(--mirror-text)]">full right to delete your
          data</strong> at any time. From Settings, choose "Delete Account &amp; History" to
          permanently remove your account, all of your conversations, and every Journey entry from
          our database. This deletion is immediate and irreversible.
        </p>
      </Section>

      <Section heading="Contact">
        <p>
          For any privacy questions, contact Gnosis Dynamics LLC.
        </p>
      </Section>
    </LegalLayout>
  );
}
